import React from 'react'
import styled from 'styled-components'
import { Spinner } from 'react-mdl'

const Container = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export default function BlockingSpinner({ children }) {
  return <Container>{children}<Spinner /></Container>
}



// WEBPACK FOOTER //
// ./src/Units/components/BlockingSpinner.js